export default __webpack_public_path__ + "static/media/shopping-4.b0c9a6be.png";